import React from 'react'
import { Select, Form, Icon, Input, Button, Row, Col, DatePicker } from 'antd';

const { Option } = Select;

export default props => {
  return(
    <div className="form-group">
      <div className="form-group-details">
        <h4>Subject Found! Please verify details below:</h4>
        {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
        {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
        <h5>Subject ID: <b>{props.subjectID}</b></h5>

        <h5>Consent Exists: <b>{props.consentExists === true ? 'Yes' : 'No' }</b></h5>

        {props.consentExists && <div className="consent-exists">
          <h5>Consent Date: <b>{props.consentExistsDate}</b></h5>
          <h5>Consent Type: <b>{props.consentExistsType}</b></h5>
          <h5>Consent Person: <b>{props.consentExistsPersonType}</b></h5>
          <h5>Consent Method: <b>{props.consentExistsMethodType}</b></h5>
          {['WithdrawConsentEmail', 'Email', 'EmailRegainedCapacity'].includes(props.consentExistsMethodType) && props.consentExistsEmailStatus && <h5>Consent Email Status: <b>{props.consentExistsEmailStatus.replace(/_/g, ' ')}</b></h5>}

          {props.consentExistsLink && (
            Array.isArray(props.consentExistsLink) ?
              (props.consentExistsLink.map(({ link, name }) => (
                <h5 key={name}>Document Link: <b><a href={link} target="_blank">{name}</a></b></h5>
              )))
              :
              (<h5>Document Link: <b><a href={props.consentExistsLink.link} target="_blank">{props.consentExistsLink.name}</a></b></h5>)
          )}
        </div>}
      </div>

      <Form.Item>
        <label>
          <span className='form-label'>Who will be providing Consent?</span>
          {props.form.getFieldDecorator('consentPersonType', {
              initialValue: props.consentPersonType || props.consentExistsPersonType,
              rules: [{
                  required: true,
                  message: 'Please select who will be providing consent'
              }],
          })(
            <Select>
              <Option value="Patient">Patient</Option>
              <Option value="Surrogate">Surrogate</Option>
            </Select>
          )}
        </label>
      </Form.Item>

      <Form.Item>
        <label>
          <span className='form-label'>Consent Type</span>
          {props.form.getFieldDecorator('consentMethodType', {
              initialValue: props.consentExistsMethodType,
              rules: [{
                  required: true,
                  message: 'Please select the type of consent desired'
              }],
          })(
            <Select>
              <Option value="Electronic">Electronic Consent</Option>
              <Option value="Paper">Paper Consent</Option>
              <Option value="Email">E-mail Consent</Option>
              {props.form.getFieldValue('consentPersonType') === 'Patient' && <Option value="RegainedCapacity">Regained Capacity Electronic</Option>}
              {props.form.getFieldValue('consentPersonType') === 'Patient' && <Option value="EmailRegainedCapacity">Regained Capacity Email</Option>}
              {props.form.getFieldValue('consentPersonType') === 'Patient' && <Option value="RegainedCapacityPaper">Regained Capacity Paper</Option>}
              {/*{props.form.getFieldValue('consentPersonType') === 'Patient' && <Option value="WithdrawConsentElectronic">Withdraw Consent Electronic</Option>}
              {props.form.getFieldValue('consentPersonType') === 'Patient' && <Option value="WithdrawConsentPaper">Withdraw Consent Paper</Option>}
              {props.form.getFieldValue('consentPersonType') === 'Patient' && <Option value="WithdrawConsentEmail">Withdraw Consent Email</Option>}*/}
            </Select>
          )}
        </label>
      </Form.Item>

      <Form.Item>
        <label>
          <span className='form-label'>Overwrite existing consent, if it exists?</span>
          {props.form.getFieldDecorator('consent_overwrite', {
              rules: [{
                  required: true,
                  message: 'You need to agree to override data if you wish to proceed with this entry!'
              }],
          })(
            <Select>
              <Option value="yes">Yes</Option>
              <Option value="">No</Option>
            </Select>
          )}
        </label>
      </Form.Item>
     </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeRoyal/Step2.js